<template>
  <Modal
    :open="isArchiveVerifier"
    :border="false"
    width="default"
    :classes="{ modalContent: 'max-md:!h-auto', header: '!border-b !border-app-gray-200' }"
    :backdrop-close="false"
    @onClose="onClose"
  >
    <template #header>
      <div class="text-xl font-semibold capitalize text-app-gray-900 dark:text-app-white">Archive Verifier?</div>
    </template>
    <template #body>
      <div>
        <div class="mb-6 text-base text-app-gray-500">
          This verifier's details will be changed to read-only and will no longer be editable by anyone unless restored. You may restore it back
          anytime to make changes.
        </div>
        <div class="text-sm mb-2 text-app-gray-900">
          Please type
          <span class="font-medium">"{{ verifier.verifier_id }}"</span>
          to confirm.
        </div>
        <TextField
          v-model="verifierId"
          :aria-label="`Please type &quot;{{ verifier.verifier_id }}&quot; to confirm.`"
          :error="v$.verifierId.$error || Boolean(error)"
          :helper-text="v$.verifierId.$error ? v$.verifierId.$errors[0].$message : error"
          @input="v$.verifierId.$validate()"
        />

        <div class="mt-5">
          <Button
            :classes="{ container: '!bg-app-error' }"
            aria-label="Archive Project"
            :disabled="sendingForm"
            :loading="sendingForm"
            block
            @click="archiveVerifier"
          >
            I understand, archive this verifier
          </Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Modal } from "@toruslabs/vue-components/Modal";
import useVuelidate from "@vuelidate/core";
import { helpers, required, sameAs } from "@vuelidate/validators";
import { defineComponent } from "vue";

import { Button } from "@/components/Button";
import { TextField } from "@/components/TextField";
import { userModule, verifierModule } from "@/store";
import { TOAST_TYPES } from "@/utils/enums";

export default defineComponent({
  name: "ArchiveVerifier",
  components: { Button, Modal, TextField },
  props: {
    isArchiveVerifier: {
      type: Boolean,
      default: false,
    },
    verifier: {
      type: Object,
      default: () => ({}),
    },
    teamName: {
      type: String,
      default: undefined,
    },
  },
  emits: ["closeDialog"],
  data: () => ({
    sendingForm: false,
    verifierId: "",
    error: "",
    v$: useVuelidate(),
  }),
  validations() {
    return {
      verifierId: {
        required: helpers.withMessage("This field is required", required),
        sameAs: helpers.withMessage("Please type the verifier identifier correctly", sameAs(this.verifier.verifier_id)),
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("closeDialog");
      this.error = "";
      this.verifierId = "";
      this.v$.verifierId.$reset();
    },
    async archiveVerifier() {
      const valid = await this.v$.verifierId.$validate();
      if (!valid) return;

      try {
        this.sendingForm = true;
        await verifierModule.archiveLegacyVerifier({
          verifierId: this.verifier.verifier_id,
          network: this.verifier.network,
          teamId: this.verifier.team_id,
        });
        userModule.setToastMessage({ message: "Verifier archived successfully", type: TOAST_TYPES.SUCCESS });
        this.onClose();
      } catch (error) {
        this.error = `Fail to archive verifier: ${(error as Error).message}`;
      } finally {
        this.sendingForm = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped></style>
